/**
 * 月曆模塊
 */
import DeteSelectOb from 'date-select-ob'
export default {
    namespaced: true,
    state: {
        deteSelectOb: new DeteSelectOb(),
        calendar: null
    },
    mutations: {
        calendarRest(state) {
            state.calendar = state.deteSelectOb.rest()
        },
        calendarNext(state) {
            state.calendar = state.deteSelectOb.next()
        },
        calendarBack(state) {
            state.calendar = state.deteSelectOb.back()
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/calendar.js